import type { ComponentProps } from 'react';
import { type IconNames, Icons } from './Icons';

export type IconProps = ComponentProps<'svg'> & {
  readonly name: IconNames;
  readonly size?: number;
  readonly title?: string;
};

const Icon = ({ name, size = 20, className, title, ...props }: IconProps) => (
  <svg
    className={className}
    viewBox={`0 0 20 20`}
    width={size}
    height={size}
    fill="currentColor"
    focusable="false"
    role="img"
    aria-hidden={!title ? 'true' : undefined}
    {...props}
  >
    {!!title && <title>{title}</title>}
    {Icons[name]}
  </svg>
);

export default Icon;
